export default []
export const alert = ['info', 'success', 'warning', 'error']
